import React from 'react';
import PropTypes from 'prop-types';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import { HighlightBox, Paragraph, CloseButton } from './styled';

const TermsModal = ({ isOpen, onClose }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      heading="Terms and conditions"
      isScrollable
    >
      Insurance terms and conditions are not always easy or fun to read, and we get that.
      So, we've provided a brief summary of each clause to help you better understand our
      terms and conditions.
      <HighlightBox>
        You and your travel companions are subscribing to the SafetyWing Special Purpose
        Trust, which holds the master insurance policy. You all have to agree to the terms
        and conditions of the Trust.
      </HighlightBox>
      <Paragraph>
        <b>Subscription</b>: I on behalf the Group, and/or the individual insureds
        (individually “I” or “Me,”; collectively “We”, “Us,” or the “Applicant(s)”) affirm
        that I am authorized by the Applicant(s) to subscribe on their behalf, and hereby
        do apply and subscribe to, and agree with all the terms of, the SafetyWing Special
        Purpose Trust (the “Trust”), a Puerto Rico special purpose trust, or its
        successor.
      </Paragraph>
      <HighlightBox>
        Once subscribed to the Trust, you can then purchase an insurance plan for you and
        your travel companions. Your eligibility to purchase is based on the information
        provided about yourself and your travel companions in the sign up process.
      </HighlightBox>
      <Paragraph>
        <b>Application</b>: Upon my/our subscription application being approved, I/We
        subsequently hereby apply for the insurance coverage requested (the “Coverage”),
        as underwritten and offered by SafetyWing Insurance I.I., a Class 3 & Class 5
        Puerto Rico- domiciled international insurer (“the Insurer”), as administered by
        the Insurer's representative and plan administrator, SafetyWing (Managing General
        Agent), Ltd, a Turks & Caicos registered managing general agent MGA (the “MGA”),
        acting by and on behalf of Trustee Services LLC (the “Trustee”), pursuant to a
        master policy issued and delivered to the Trust in Puerto Rico.
      </Paragraph>
      <HighlightBox>
        <ul>
          <li>
            This insurance is only for unexpected illness or injuries while outside of my
            home country, and it fits my needs.
          </li>
          <li>
            This insurance is only effective once I have paid the premium, and that
            coverage can be lost if payments are not up to date.
          </li>
          <li>
            If I want to make changes to my application, the insurance company must
            approve them in writing.
          </li>
          <li>
            All the information I gave is true and that my insurance may be voided if any
            information is found to be false, and I will have to cover SafetyWing's legal
            costs.
          </li>
          <li>
            Coverage is provided by SafetyWing Insurance I.I., the insurer, and not
            SafetyWing (Managing General Agent) Ltd., the plan administrator.
          </li>
        </ul>
      </HighlightBox>
      <Paragraph>
        <b>Applicant's Understandings</b>: I/we understand and agree that: (i) the
        Coverage is not a general health insurance product and is designed to cover but is
        intended for use as travel coverage in the event of a sudden and unexpected
        illness or injury while traveling outside of my/our Home Country and the Coverage
        is suitable for my/our needs; (ii) no coverage will be effective until the
        required premium has been paid and this application has been accepted in writing
        by the Insurer, and failure to pay all premiums may result in loss of coverage;
        (iii) no modiﬁcation relating to this application or the Coverage will be binding
        upon the Insurer or Administrator unless approved in writing by an ofﬁcer of the
        Insurer or Administrator; (iiiv) I/We represent and warrant the truthfulness of
        all information provided herein, including the eligibility criteria, and further
        understand that any misrepresentation or omission contained herein will void the
        Coverage, any and all claims and beneﬁts thereunder will be forfeited and waived,
        and I/We hereby indemnify the Insurer and Trustee for any expenses (including
        attorney fees) incurred as a result of any misrepresentations made by Me/Us
        herein; (iv) the subjects of insurance applied for are not intended or considered
        by Me/us, the Insurer, or the MGA to be resident, located, or expressly to be
        performed in any particular jurisdiction; and (vi) the Insurer is solely liable
        for the Coverage to be provided and MGA has no direct or independent liability
        under the Coverage.
      </Paragraph>
      <HighlightBox>
        You agree to allow SafetyWing to process ongoing payments for your insurance plan.
        Subscription plans automatically restart once it reaches the 364-day limit.
        Payments will continue until you stop your plan in your member dashboard.
      </HighlightBox>
      <Paragraph>
        <b>Payment</b>: I hereby authorize SafetyWing or its designee to process this
        payment for this and every future premium payment on my insurance plans. For
        short-term plans, such as Nomad Insurance, I understand that my plan is extended
        every 28 days, up to 364 days. After 364 days, my initial plan will fully lapse.
        In such an event, I hereby opt-in and authorize SafetyWing to automatically enroll
        me into a new plan purchased with my payment information on-file at that time for
        the benefits and rates offered at that time, unless or until I opt-out of the
        program via the Member dashboard.
      </Paragraph>
      <HighlightBox>
        By clicking 'confirm payment', you and SafetyWing are legally bound to this
        agreement.
      </HighlightBox>
      <Paragraph>
        <b>Binding Effect</b>: By submitting this application and/or signing this
        Subscription Agreement and Insurance Application, and/or submission of any future
        claim for beneﬁts, I/We ratify the authority of the signer to so act and bind
        Me/Us, who hereby purposefully initiate and take advantage of the privilege of
        conducting business in the Turks and Caicos Islands through the Insurer's MGA, and
        the Coverage will be deemed issued and made in Puerto Rico, with sole and
        exclusive jurisdiction, and venue, and applicable law for any legal proceeding
        relating to the Coverage in Puerto Rico, for which I/We hereby expressly consent.
        I/We consent and agree that Puerto Rico shall be the sole and exclusive venue and
        applicable law governing all rights and claims raised under the Coverage, without
        regard to Puerto Rico's conflict of laws principles.
      </Paragraph>
      <CloseButton color="pickledBluewood" onClick={onClose}>
        Close
      </CloseButton>
    </BaseModal>
  );
};

TermsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TermsModal;
